import { CareRecipient } from '@app/core/api/care-links';

/**
 * Care state interface for NgRx store
 */
export interface CareState {
  careRecipients: CareRecipient[];
  selectedRecipientId: string | null;
  loading: boolean;
  error: string | null;
}

/**
 * Initial state for care feature
 */
export const initialCareState: CareState = {
  careRecipients: [],
  selectedRecipientId: null,
  loading: false,
  error: null
};
